const { mainConfigService } = require('./config');
const { ONE_LAST_CHECK_EVENTS } = require('../constants');
const { oneLastCheckSheet } = require('../html');

const OLC_SHEET_SELECTOR = '#ottu__sdk-olc-sheet';
const OLC_ACTIVE_CLASS = 'ottu__sdk-olc-active';

class OneLastCheckService {
  constructor(documentCheckout) {
    this.documentCheckout = documentCheckout;
    this._timerInterval = null;
    this._destroyed = false;
    this._resolveGate = null;
  }

  show() {
    const config = mainConfigService.get('oneLastCheck');
    if (!config || !Array.isArray(config.items)) {
      return Promise.resolve({ proceed: true, via: 'no-config' });
    }

    if (this._resolveGate) {
      return Promise.resolve({ proceed: false, via: 'already-showing' });
    }

    return new Promise((resolve) => {
      this._destroyed = false;
      this._resolveGate = resolve;

      const existing = this.documentCheckout.querySelector(OLC_SHEET_SELECTOR);
      if (existing) existing.remove();

      const mainEl = this.documentCheckout.querySelector('.ottu__sdk-main');
      if (!mainEl) {
        this._resolveGate = null;
        resolve({ proceed: true, via: 'no-container' });
        return;
      }

      mainEl.insertAdjacentHTML('afterend', oneLastCheckSheet());
      const sheetEl = this.documentCheckout.querySelector(OLC_SHEET_SELECTOR);

      window.dispatchEvent(new CustomEvent(ONE_LAST_CHECK_EVENTS.SHOWN));

      requestAnimationFrame(() => {
        sheetEl.classList.add(OLC_ACTIVE_CLASS);
        const firstBtn = sheetEl.querySelector('[data-testid="ottu-sdk-olc-confirm"]');
        if (firstBtn) firstBtn.focus();
      });

      const confirmBtn = sheetEl.querySelector('[data-testid="ottu-sdk-olc-confirm"]');
      const editBtn = sheetEl.querySelector('[data-testid="ottu-sdk-olc-edit"]');
      if (confirmBtn) confirmBtn.addEventListener('click', () => this._onConfirm('user'));
      if (editBtn) editBtn.addEventListener('click', () => this._onEdit());

      this._startCountdown(config, sheetEl);
    });
  }

  _startCountdown(config, sheetEl) {
    const durationSeconds = config.durationSeconds || 10;
    let remaining = durationSeconds;

    const countdownEl = sheetEl.querySelector('.ottu__sdk-olc-countdown');
    const progressBar = sheetEl.querySelector('.ottu__sdk-olc-progress-bar');

    this._timerInterval = setInterval(() => {
      remaining -= 1;

      if (countdownEl) {
        countdownEl.textContent = this._formatTime(remaining);
      }
      if (progressBar) {
        const pct = Math.max(0, (remaining / durationSeconds) * 100);
        progressBar.style.width = `${pct}%`;
      }

      if (remaining <= 0) {
        clearInterval(this._timerInterval);
        this._timerInterval = null;
        if (!this._destroyed) {
          this._onConfirm('timeout');
        }
      }
    }, 1000);
  }

  _formatTime(seconds) {
    const s = Math.max(0, seconds);
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return `${String(m).padStart(2, '0')}.${String(sec).padStart(2, '0')}`;
  }

  _onConfirm(via) {
    if (this._destroyed) return;
    this._destroyed = true;
    this._cleanup();
    const resolve = this._resolveGate;
    this._resolveGate = null;
    window.dispatchEvent(new CustomEvent(ONE_LAST_CHECK_EVENTS.CONFIRMED, { detail: { via } }));
    resolve({ proceed: true, via });
  }

  _onEdit() {
    if (this._destroyed) return;
    this._destroyed = true;
    this._cleanup();
    const resolve = this._resolveGate;
    this._resolveGate = null;
    window.dispatchEvent(new CustomEvent(ONE_LAST_CHECK_EVENTS.EDIT_REQUESTED));
    resolve({ proceed: false });
  }

  _cleanup() {
    if (this._timerInterval) {
      clearInterval(this._timerInterval);
      this._timerInterval = null;
    }
    const sheetEl = this.documentCheckout.querySelector(OLC_SHEET_SELECTOR);
    if (sheetEl) {
      sheetEl.classList.remove(OLC_ACTIVE_CLASS);
      setTimeout(() => { if (sheetEl.parentNode) sheetEl.remove(); }, 400); 
    }
  }

  destroy() {
    this._destroyed = true;
    if (this._timerInterval) {
      clearInterval(this._timerInterval);
      this._timerInterval = null;
    }
    const sheetEl = this.documentCheckout.querySelector(OLC_SHEET_SELECTOR);
    if (sheetEl) sheetEl.remove();
    if (this._resolveGate) {
      this._resolveGate({ proceed: false, destroyed: true });
      this._resolveGate = null;
    }
  }
}

module.exports = OneLastCheckService;
